const getShiftDetailPending = state => state.shiftDetail.shiftDetailPending;
const getShiftDetailRes = state => state.shiftDetail.shiftDetailRes;
const getShiftDetailError = state => state.shiftDetail.shiftDetailError;
export default {
  getShiftDetailPending,
  getShiftDetailRes,
  getShiftDetailError,
};
